import React, { memo, useContext } from 'react'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import GenerateArea from 'Pods/ThreeDStudio/Shared/GenerateArea/GenerateArea'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import ThreeDStudioPageContext from 'Pods/ThreeDStudio/ThreeDStudioPageContext'

import ComingSoon from './Components/ComingSoon/ComingSoon'
import PromptField from './Components/PromptField/PromptField'
import StyleField from './Components/StyleField/StyleField'
import StyleStrengthField from './Components/StyleStrengthField/StyleStrengthField'

function RenderTab() {
  const t = useTranslation()
  const { enable2dRender } = useContext(ThreeDStudioPageContext)
  const prompt = useThreeDStudioStore(state => state.renderSettings.prompt)
  const hasStyle = useThreeDStudioStore(state => state.renderSettings.styles.length > 0)
  // A style-apply carries its own instruction, so the prompt is only required for a plain
  // render. Whitespace alone is not a prompt.
  const isMissingInput = !hasStyle && !prompt?.trim()

  if (!enable2dRender) {
    return <ComingSoon />
  }

  return (
    <>
      <div className="render-tab enhance-model-panel__tab">
        <span className="enhance-model-panel__title cgt-heading-50">
          {t('viewerSidebar.enhance.render.title')}
        </span>
        <p className="render-tab__hint cgt-body-base">
          <img
            className="render-tab__hint-icon"
            src="/assets/three_d_studio/render_tab/mouse.svg"
            alt=""
            aria-hidden="true"
            width={16}
            height={16}
          />
          {t('viewerSidebar.enhance.render.viewerHint')}
        </p>
        <div className="enhance-model-panel__settings">
          <PromptField />
          <StyleField />
          <StyleStrengthField />
        </div>
      </div>
      <GenerateArea
        generateLabel={t('viewerSidebar.enhance.render.generateLabel')}
        generatedLabel={t('viewerSidebar.enhance.common.done')}
        generatingLabel={t('viewerSidebar.enhance.common.processing')}
        isEnhancementMode
        isGenerateDisabled={isMissingInput}
        withIcon={false}
      />
    </>
  )
}

export default memo(RenderTab)
